import HttpClienteToken from '../../services/HttpClientToken';

import { defaultSala, SalaAsignarProps, SalaProps } from '../../interfaces/catalogos/SalaInterface';

export const Sala = () => {

    return new Promise<SalaProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Sala/', token)
            .then( ({ data } : { data : SalaProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerSala = () => {

    return new Promise<SalaAsignarProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Sala/ObtenerSala', token)
            .then( ({ data } : { data : SalaAsignarProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarSala = ( params: SalaProps ) => {

    return new Promise<SalaProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Sala/Actualizar', params, token)
            .then( ({ data } : { data : SalaProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( { ...defaultSala });
            });
        }

    });

}

export const AgregarSala = ( params: SalaProps ) => {

    return new Promise<SalaProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Sala/Agregar', params, token)
            .then( ({ data } : { data : SalaProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( { ...defaultSala });
            });
        }

    });

}